module.exports = __webpack_public_path__ + "static/media/6634.13047b10.jpg";